import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import {
  RmSelectV3Component,
  SearchFilterPipe,
} from './rm-select-v3.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ImageModule } from '@web-frontend/shared/pipes/image';
import { CurrencyFormatModule } from '@web-frontend/shared/pipes/currency-format/currency-format.module';

@NgModule({
  declarations: [RmSelectV3Component, SearchFilterPipe],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatProgressSpinnerModule,
    MatCheckboxModule,
    CurrencyFormatModule,
    ImageModule.forRoot(),
  ],
  providers: [TitleCasePipe],
  exports: [RmSelectV3Component],
})
export class RmSelectV3Module {}
